<template>
    <q-card
            :inline="inline"
            :class="['card', 'q-ma-sm', {inEdit: inEdit, draggingOver: draggingOver}]"
            :style="style"
            ref="card">
        <q-card-title class="title">
            <div v-if="! inEdit">{{localModel.name}}</div>
            <q-input v-else v-model="localModel.name"></q-input>
        </q-card-title>

        <q-card-media class="media q-pa-md"
                      @dragover.native.prevent="dragover"
                      @dragleave.native="dragleave"
                      @drop.native="drop"
                      @dragenter.native="dragenter">
            <generic-viewer :tasklet="localModel.tasklet"/>
        </q-card-media>

        <q-card-main class="main">
            <p v-if="! inEdit" v-html="localModel.description"></p>
            <q-editor @paste.native="paste" v-if="inEdit && localModel.description != null" v-model="localModel.description"/>
        </q-card-main>

        <q-card-actions v-if="!inEdit" align="end" class="actions">
            <q-btn flat round icon="edit" @click.native="goToEdit(localModel.id)"/>
            <q-btn flat round icon="delete" @click.native="confirmAndDelete"/>
        </q-card-actions>

        <q-card-actions v-if="inEdit" align="end" class="actions"
                        @dragover.native.prevent="dragover"
                        @dragleave.native="dragleave"
                        @dragenter.native="dragenter"
                        @drop.native="dropBackground">
            <q-btn flat round icon="save" @click.native="save"/>
            <q-btn flat round icon="delete" @click.native="confirmAndDelete"/>
        </q-card-actions>
    </q-card>
</template>

<script>
    import QCardTitle from 'quasar-framework/src/components/card/QCardTitle'
    import QCardMedia from 'quasar-framework/src/components/card/QCardMedia'
    import QCardMain from 'quasar-framework/src/components/card/QCardMain'
    import QCardActions from 'quasar-framework/src/components/card/QCardActions'
    import QIcon from 'quasar-framework/src/components/icon/QIcon'
    import QBtn from 'quasar-framework/src/components/btn/QBtn'
    import QEditor from 'quasar-framework/src/components/editor/QEditor'
    import QField from 'quasar-framework/src/components/field/QField'
    import GenericViewer from './viewers/GenericViewer'
    import QCard from 'quasar-framework/src/components/card/QCard'
    import { pasteCapture } from '../../lib/editor-paste'

    export default {
        name: 'TaskletComponent',
        components: {QCard, GenericViewer, QField, QEditor, QBtn, QIcon, QCardActions, QCardMain, QCardMedia, QCardTitle},
        props: ['model', 'editable', 'inEdit', 'inline'],
        methods: {
            paste (evt) {
                pasteCapture(evt, this.$refs.editor_ref);
            },
            goToEdit (id) {
                this.$router.push({
                    name: 'pole-edit',
                    params: {id},
                })
            },
            confirmAndDelete () {
                if (this.localModel.id) {
                    this.$q.dialog({
                        title: `Potwierdź usunięcie podzadania`,
                        message: `Czy na pewno usunąć podzadanie ${this.localModel.name}?`,
                        ok: 'Usuń',
                        cancel: 'Anuluj',
                        position: 'top',
                    }).then(() => {

                    }).catch(() => {

                    })
                } else {
                    this.$emit('delete');
                }
            },

            dragenter () {

            },
            dragover () {
                if (this.inEdit) {
                    this.draggingOver = true
                }
            },
            dragleave () {
                if (this.inEdit) {
                    this.draggingOver = false
                }
            },
            drop (e) {
                if (this.inEdit) {
                    e.preventDefault()

                    try {
                        this.localModel.tasklet = JSON.parse(e.dataTransfer.getData('text'))
                    } catch (ee) {
                        // ...
                    }

                    this.draggingOver = false
                }
            },
            dropBackground (/*e*/) {
                if (this.inEdit) {
                    try {
                        this.$set(this.localModel, 'background', JSON.parse(e.dataTransfer.getData('text')).id)
                    } catch (ee) {
                        // ...
                    }
                }
            },
            save () {

            },
            fetch() {

            },
            fetchDetailsIfNecessary () {

            },
        },
        data () {
            return {
                draggingOver: false,
                isNew: false,
            }
        },
        mounted () {
            // this.fetchDetailsIfNecessary()
        },
        watch: {
            // model (now, old) {
            //     if (now.id && now.id !== old.id){
            //         this.fetchDetailsIfNecessary()
            //     }
            // },
        },
        computed: {
            localModel () {
                if (this.fullModel) {
                    return this.fullModel
                } else {
                    this.$store.dispatch('fetchTasklet', this.model.id)
                    return this.model;
                }
            },
            fullModel () {
                return this.$store.state.tasklets.find(t => t.id === this.model.id)
            },
            style () {
                if (this.localModel.background) {
                    const pictureModel = this.$store.getters.pictures.find(m => m.id === this.localModel.background)
                    if (pictureModel) {
                        // return `background: url(${this.$uploadedPath(pictureModel)}); background-size: cover`
                    } else {

                    }
                }
            },
        }
    }
</script>

<style scoped lang="scss">
    .card {
        .actions {
            background: gainsboro;
        }

        border-radius: 20px;
    }

    .card:not(.inEdit) {
        width: 350px;
        height: 500px;
        overflow: hidden;
        position: relative;

        .media {

        }

        .main {

        }

        .actions {
            display: none;
        }

        &:hover .actions {
            display: flex;
        }
    }

    .card.inEdit {
        width: 350px;
        position: relative;

        .media {

        }

        .main {

        }

        &.draggingOver {
            border: 1px solid red;
        }
    }

</style>
